<template>
    
    <v-card    class="mx-auto"    max-width="500"  >

      


      <h4 class="pa-3 display-1" >Faça seu agendamento</h4>
      
      
      
      <AgradecimentoDialog :stateDialog="dialogAgradecimentoState" />
    <v-card-title class="title font-weight-regular justify-space-between">
      <span>{{ currentTitle }}</span>
      <v-avatar
        color="primary lighten-2"
        class="subheading white--text"
        size="24"
        v-text="step"
      ></v-avatar>
    </v-card-title>

    <v-window v-model="step">
      <v-window-item :value="1">
        <v-card-text>
            
        <v-select  :items="servicos" item-text="descTempo" 
        item-value="id" v-model="servicoEscolhido"  
        label="Serviços" @change="ajustarBarbeiros" prepend-icon="mdi-share"  >
        </v-select>


            <!--
          <v-text-field
            label="Email"
            value="john@vuetifyjs.com"
          ></v-text-field>
          -->
          <span  class="caption grey--text text--darken-1">
            Escolha o tipo de serviço que você quer agendar.
          </span>

          <br>
            <span  class="caption grey--text text--darken-1" v-if="servicoEscolhidoObjeto.descricao">
           Serviço escolhido: <strong class="blue--text darken-1">{{ servicoEscolhidoObjeto.descricao +  " R$ " + servicoEscolhidoObjeto.preco + " - "+ servicoEscolhidoObjeto.tempo.replace("m", " minutos")}}</strong>
          </span>
        <br>
        <br>
        
        <v-select prepend-icon="mdi-face" 
         :items="barbeirosFiltrados" 
         item-text="nome" 
         item-value="id"
         v-model="barbeiroEscolhido" @change="zerarHorarios" label="Barbeiros"></v-select>

          <span class="caption grey--text text--darken-1">
            Escolha o barbeiro
          </span>
        </v-card-text>
      </v-window-item>

      <v-window-item :value="2">
        <v-card-text>
            <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="date"
            transition="scale-transition"
            offset-y
            min-width="290px">
            <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="date"
                label="Escolha uma data"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
            </template>
            <v-date-picker :min="minDate" v-model="date" locale="pt-br" no-title scrollable @change="gerarHorariosDisponiveis" >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menu = false">Fechar</v-btn>
            <!-- <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn> -->
            </v-date-picker>
        </v-menu>
        <span v-if="fecharAgenda" class="red--text" >Este dia não haverá expediente para o barbeiro escolhido</span>
        <br>
        <br>
            <span class="caption grey--text text--darken-1">Escolha horário</span>
        <v-select prepend-icon="fa fa-clock" no-data-text="Sem horários disponíveis para este dia"
         :items="horariosFiltrados" 
       
         v-model="horarioEscolhido" label="Horários" ></v-select>

       
        </v-card-text>
      </v-window-item>

      <v-window-item :value="3">
        <div class="pa-4 text-center">
          <h3 class="title font-weight-light mb-2">Falta pouco, informe seu Nome e Telefone</h3>
          <v-layout row class="pa-5" >
            <v-flex xs12 sm6 class="px-2" >
              <v-text-field label="Nome" prepend-icon="mdi-account" v-model="user.nome" ></v-text-field>
            </v-flex>
          <v-flex xs12 sm6 class="px-2" >
                <!-- <v-text-field label="telefone" type="text" prepend-icon="fa fa-phone" placeholder="(00)00000-0000 " v-model="user.telefone" ></v-text-field> -->
              <v-text-field label="telefone" v-mask="'(##)#####-####'" type="text" prepend-icon="fa fa-phone" placeholder="(00)00000-0000 " v-model="user.telefone" ></v-text-field> 

            </v-flex>

            <v-flex xs12 sm12 class="px-2" >
              <v-text-field label="Email" :rules="emailRules" type="email" prepend-icon="fa fa-envelope-square" v-model="user.email" ></v-text-field>
            </v-flex>
          
          </v-layout>
          
        </div>
      </v-window-item>

      
    </v-window>

    <v-divider></v-divider>

    <v-card-actions>
      <v-btn
        :disabled="step === 1"
        text
        @click="step--"
      >
        Voltar
      </v-btn>
     
      <v-spacer></v-spacer>
      <v-btn
        v-if="!(step == 3)"
        :disabled="checarBotao()"
        color="primary"
        depressed
        @click="step++"
        
        
      >
        Próximo
      </v-btn>
      <v-btn class="success"  v-if="(step == 3)" :disabled="checarBotaoEnviar()" @click="enviarAgendamento" >
        Concluir!
      </v-btn>
    </v-card-actions>
  </v-card>
  
</template>

<script>
//import firebase from 'firebase'
import {refAgenda, refBarbeiros,refFuncoes, refFeriados, refConfiguracoes} from '@/firebaseConfig'
import AgradecimentoDialog from './AgradecimentoDialog'

//import {mapActions} from 'vuex'
    export default {
      components: {
        AgradecimentoDialog
      },
      
    data: () => ({

      refServicos: refFuncoes,
      refBarbeiros: refBarbeiros,
      refAgenda: refAgenda,
      refFeriados: refFeriados,
      refConfiguracoes: refConfiguracoes,
      // listaHorariosExibir: [],
      fecharAgenda: false,
      user: {telefone:'', nome: '', email:''},
      date:'', //new Date().toISOString().substr(0, 10),
      minDate: new Date().toISOString().substr(0, 10),
      ajusteHoras: -10800000,
      menu: false,
      today: null,
      step: 1,
      servicos: [],
      barbeiros:[],
      events : [],
      horariosFiltrados:[],
      barbeirosFiltrados: [],
      horarioEscolhido: "",
      servicoEscolhido: "",
      barbeiroEscolhido: "",
      barbeiroEscolhidoObjeto: {},
      servicoEscolhidoObjeto: {},
      dialogAgradecimentoState: false,
      agendamentoPronto: '',
      emailRules: [
        v => !!v || 'E-mail é obrigatório',
        v => /.+@.+\..+/.test(v) || 'E-mail precisa ser váilido',
      ],

    }),
   created(){
      
        this.carregarServicos();
        this.carregarBarbeiros();
       
    },
    methods: {
      
        //  ...mapActions(),
          campoVazio(value){
            return value === '' || typeof value === 'undefined' || value == null
          },

          checarBotao(){
            if(this.step == 1){
              return  this.campoVazio(this.servicoEscolhido) ||  this.campoVazio(this.barbeiroEscolhido)
              
            }else if(this.step == 2){
              return this.campoVazio(this.date) || this.campoVazio(this.horarioEscolhido)
            }

          },

          checarBotaoEnviar(){
            return this.campoVazio(this.user.telefone)
            || this.campoVazio(this.user.nome)
            || this.campoVazio(this.user.email)
          },

          zerarHorarios(){
              this.horariosFiltrados = [];
              this.horarioEscolhido = ''
              //this.date = null
          },

          buscarAgenda(){
              this.events = []
              this.refAgenda.where("barbeiro.id", '==', this.barbeiroEscolhido).get().then((snap)=> {
                  snap.forEach((doc)=>{
                      this.events.push({...doc.data()})
                  });
              });
                
            },
          
          carregarServicos(){

              this.refServicos.orderBy("descricao","asc").get().then((snap)=>{
                snap.forEach((doc)=>{
                  var descricaoTempo = doc.data().descricao + " - " + doc.data().tempo.replace("m","min.") + " - R$ " +  doc.data().preco.toLocaleString()
                  this.servicos.push({...doc.data(), descTempo: descricaoTempo});
                });

              });
            },
            carregarBarbeiros(){
            this.refBarbeiros.orderBy("nome","asc").get().then((snap)=>{
                    snap.forEach((doc)=>{
                      
                      this.barbeiros.push({...doc.data()});
                    });

                  });
            },
            ajustarBarbeiros(){
              this.barbeirosFiltrados = [];
              this.zerarHorarios()
              //this.horariosFiltrados = [];
                this.barbeiros.filter(barbeiro => {
                    return barbeiro.funcoes.filter(servico => {
                        if(servico == this.servicoEscolhido){
                            //alert(barbeiro.nome);
                            
                            this.barbeirosFiltrados.push(barbeiro);
                            return barbeiro;
                        }
                    });
                });
                  this.servicoEscolhidoObjeto = this.filtrarServico();

              //console.log(this.barbeirosFiltrados);
              },
            
            async gerarHorariosDisponiveis(){
              this.horarioEscolhido = ''
              this.horariosFiltrados = []
              //separar barbeiro escolhido
              this.barbeiroEscolhidoObjeto = this.filtrarBarbeiro();
              //separar servico         
              this.servicoEscolhidoObjeto = this.filtrarServico();
              
              //checar dia da semana

              var dia = new Date(this.date)
              //Aqui eu preciso ajustar, pois inicia a segunda no 0
              //porém o JS inicia no DOMINGO no 0
              dia = dia.getUTCDay() - 1
              
              dia = dia < 0 ? 6 : dia
              console.log("---------- DIA UTC", dia);
              //carrego os horários do barbeiro
              var diaBarbeiro = this.barbeiroEscolhidoObjeto.horarios[dia]
              //por padrão é FALSO
              this.fecharAgenda = false
              //checar se haverá expediente no dia
              this.fecharAgenda = await this.checarFeriados();
              //console.log("Horarios UM");
              if(!this.fecharAgenda){

                  if(diaBarbeiro.horaIni !== ""){
                    //diaBarbeiro
                    //gera os horários totais para cada barbeiro com base no horario inicio e fim do dia
                    this.gerarListaHorarios(diaBarbeiro)
                  //this.horariosFiltrados = this.barbeiroEscolhidoObjeto.horarios.horariosUm;
                  
                  this.verificarHorasDisponiveis(diaBarbeiro);
                  //console.log("Horarios UM",this.horariosFiltrados);

                  
                  }else{
                    //console.log("Sem horários para este dia")
                    //this.horariosFiltrados = [];
                    this.zerarHorarios()
                  }
                
              }else{
                console.log("Agenda fechada");
              }
              this.$refs.menu.save(this.date)
            
            },

            corrigirHorarioLocale(dia, hora){
              console.log(dia, hora);
              // let correcaoHorario = (180 * 60 * 1000)
              // let reducaoHorario = new Date().getTimezoneOffset() * 60 * 1000
              // let dateTimeIni = new Date(dia + "T" + hora).getTime() - reducaoHorario + correcaoHorario
              // return dateTimeIni + " " + new Date(dateTimeIni)
              // console.log(dateTimeIni);
              return new Date("2020-10-16T11:00-03:00").getTime()
              
            },
            async gerarListaHorarios(diaBarbeiro){
              // let correcaoHorario = (180 * 60 * 1000)
              // let reducaoHorario = new Date().getTimezoneOffset() * 60 * 1000
              // let fatorMultiplicacao = correcaoHorario 
              // console.log(fatorMultiplicacao);
              // let dateTimeIni = new Date(this.date + "T" + diaBarbeiro.horaIni).getTime() + fatorMultiplicacao
              // let dateTimeFim = new Date(this.date + "T" + diaBarbeiro.horaFim).getTime() + fatorMultiplicacao
              let dateTimeIni = new Date(this.date + "T" + diaBarbeiro.horaIni+"-03:00").getTime()
              let dateTimeFim = new Date(this.date + "T" + diaBarbeiro.horaFim+"-03:00").getTime()
              let diffHoras = (((dateTimeFim - dateTimeIni) / 1000) / 60 ) / 60
              

              // CASO QUEIRA ALTERAR AQUI, PRECISA MEXER NOS QUARTERS
              // let quarterHours = ["00", "30"]
              // let quarterHours = ["00", "20", "40" ]
              // let quarterHours = ["00", "10", "20", "30", "40", "50"]
              
              // let quarterHours = await this.listaHorariosExibir()
              // console.log(quarterHours);
              let horaInicial = parseInt(diaBarbeiro.horaIni.split(":")[0])
              
                await this.gerarHorariosDiaV2(dateTimeIni,dateTimeFim)

                for(let i = horaInicial; i <= (diffHoras + horaInicial); i++){
                   
                  //  Este método depende do quarterHours (foi removido)
                    // this.gerarHorariosDia(quarterHours, horaInicial,diaBarbeiro, i, diffHoras)
                   
                    //Setado 0 para não dar problema onde estou somando..
                    // let fatorMultiplicacao = new Date().getTimezoneOffset() != 180 ? (180 * 60 * 1000) : 0
                    let fatorMultiplicacao = 0
                    
                    this.horariosFiltrados = this.horariosFiltrados.filter((hora) =>{
                  
                          var dataString = this.date + "T" + hora+"-03:00";
                        
                          var horaVisivel = new Date(dataString).getTime() + fatorMultiplicacao;
                          
                          var horaAlmocoIni = new Date(this.date + "T" + diaBarbeiro.almocoIni+"-03:00").getTime() + fatorMultiplicacao
                          var horaAlmocoFim = new Date(this.date + "T" + diaBarbeiro.almocoFim+"-03:00").getTime() + fatorMultiplicacao
                          var horaExpedienteFim = new Date(this.date + "T" + diaBarbeiro.horaFim+"-03:00").getTime() + fatorMultiplicacao

                                    //ex de 1 hra
                          var minutoServico = parseFloat(this.servicoEscolhidoObjeto.tempo.replace("m",""));
                          var tempoServicoMilliSeconds = ((minutoServico * 60) * 1000);

                          var horaVisivelFinal = horaVisivel + tempoServicoMilliSeconds;

                            if(horaVisivel >= horaAlmocoIni && horaVisivel < horaAlmocoFim || horaVisivelFinal > horaAlmocoIni && horaVisivelFinal <= horaAlmocoFim){
                              return false
                            }
                            //Esconder horário de FIM com base no horario escolhido e também no término do serviço
                            if(horaVisivelFinal > horaExpedienteFim){
                              return false
                            }
                            return true
                    });
                
                    
                }
            },

          async gerarHorariosDiaV2(dateTimeIni,dateTimeFim){
            let minutosExibir = await this.totalHorariosExibir()
            let dateTimeDiff = dateTimeFim - dateTimeIni;
            let mult = (minutosExibir * 60 )* 1000
            let ciclo = dateTimeDiff / mult
            console.log(ciclo);
            // console.log(dateTimeIni);
            //arredondar ciclo para cima
            for(var i = 0; i <= ciclo; i++){
              let horaAdicionar = new Date(dateTimeIni).getUTCHours() - 3
              let minutoAdicionar = new Date(dateTimeIni).getMinutes()
              
              horaAdicionar = horaAdicionar < 10 ? "0" + horaAdicionar.toString() : horaAdicionar.toString()
              minutoAdicionar = minutoAdicionar < 10 ? "0" + minutoAdicionar.toString() : minutoAdicionar.toString()
              
              let horarioString = horaAdicionar + ":"+ minutoAdicionar
              console.log("Horário add", horarioString);
              this.horariosFiltrados.push(horarioString);
              dateTimeIni = dateTimeIni + mult;
            }
              
          },
          gerarHorariosDia(quarterHours, horaInicial,diaBarbeiro,i,diffHoras){
             let stringHour = '';
                   // console.log('i', i);
                  //  console.log('dif',diffHoras);
                    quarterHours.forEach(quart =>{
                      let minutoInicio= parseInt(diaBarbeiro.horaIni.split(":")[1])
                      let minutoFim= parseInt(diaBarbeiro.horaFim.split(":")[1])
                      let quartInt = parseInt(quart)
                      //se for primeiro horario
                      //preciso exibir somente os minutos de abertura
                      if(i == horaInicial ){
                        
                        if(quartInt >= minutoInicio ){
                            stringHour =  i < 10 ? `0${i}:${quart}` : `${i}:${quart}`
                            this.horariosFiltrados.push(stringHour)
                        }
                      }else{
                        if(i == (diffHoras + horaInicial)){
                         
                        if(quartInt  <= minutoFim){
                            stringHour =  i < 10 ? `0${i}:${quart}` : `${i}:${quart}`
                            this.horariosFiltrados.push(stringHour)
                        }
                        }else{
                        
                        stringHour =  i < 10 ? `0${i}:${quart}` : `${i}:${quart}`
                        this.horariosFiltrados.push(stringHour)
                        }
                      }
                      
                    });

          },
            async checarFeriados(){
              var feriadoBuscado = await refFeriados.where("data","==",this.date).get();
              var fecharAgenda = false;
              
              if(feriadoBuscado.docs[0]){

                //console.log(feriadoBuscado.docs[0].data());
                feriadoBuscado.docs[0].data().barbeiros.forEach(barb=>{
                  if(barb.id === this.barbeiroEscolhidoObjeto.id){
                    fecharAgenda = true
                  }
                })
               /* feriadoBuscado.docs.forEach((val)=>{
                  console.log();
                });*/this.date
               // console.log(feriadoBuscado.docs[0]["barbeiros"]);
              }
              return fecharAgenda
            },
            filtrarBarbeiro(){
              return this.barbeiros.find(barbeiro => {
                  if(barbeiro.id == this.barbeiroEscolhido){
                    //barbeiroAtual = barbeiro;
                    return barbeiro
                  }});
            },


            filtrarServico(){
            return this.servicos.find(servico => {
                  if(servico.id == this.servicoEscolhido){
                    return servico;
                  }});
            },

          enviarAgendamento(){
            // let fatorMultiplicacao = new Date().getTimezoneOffset() != 180 ? (180 * 60 * 1000) : 0

            var horaFinal = this.calcularHoraFinal()
            var agenda = {
              barbeiro: {...this.barbeiroEscolhidoObjeto},
              servico: {...this.servicoEscolhidoObjeto},
              cliente: {...this.user},
              name: this.user.nome + " p/ " + this.barbeiroEscolhidoObjeto.nome,
              start: this.date + "T" + this.horarioEscolhido,
              end: this.date + "T" + horaFinal,
              dataQuery: new Date(this.date+"T00:00-03:00").getTime(),// + fatorMultiplicacao
              searchTermsArray: this.gerarTermosParaPesquisa()
            }
            this.$store.dispatch('addAgendamento', agenda)
            //console.log(this.$store.getters.agendamento)
            //console.log(agenda)
            

              this.refAgenda.add(agenda).then((ref)=>{
                ref.update({id: ref.id});
                this.$store.dispatch('addAgendamento', agenda)
                
                this.dialogAgradecimentoState = true
  
              });
            
          },
           gerarTermosParaPesquisa(){
            //gerar termos para pesquisa
            let searchTermsArray = this.user.nome.split(" ")
            searchTermsArray = searchTermsArray.map(term => {
              term = term.toLowerCase();
              term = term.normalize('NFD').replace(/[\u0300-\u036f]/g, "");

              return term
            });

            return searchTermsArray;

      },
          calcularHoraFinal(){
            // let fatorMultiplicacao = new Date().getTimezoneOffset() != 180 ? (180 * 60 * 1000) : 0

            var minutosServico = parseFloat(this.servicoEscolhidoObjeto.tempo.replace("m",""));
            var tempoServico = (minutosServico * 60) * 1000
            //var minutoEscolhido = this.horarioEscolhido.split(":")[1]
            console.log("HORÁRIO FINAL",this.addMinutos(this.horarioEscolhido,minutosServico));
            
            // var milisecondesToday = new Date(this.date + "T" + this.horarioEscolhido).getTime() + fatorMultiplicacao
            var milisecondesToday = new Date(this.date + "T" + this.horarioEscolhido+"-03:00").getTime()
            var milisecondsFinal = milisecondesToday + tempoServico 
            // var horaFinal = new Date(milisecondsFinal).getHours() //+ (((fatorMultiplicacao / 1000) / 60) / 60 )
            var horaFinal = new Date(milisecondsFinal) 
            horaFinal = horaFinal.toLocaleTimeString("pt-BR", {timeZone: "America/Sao_Paulo"})
            horaFinal = horaFinal.split(":")[0]
            var minutosFinal = new Date(milisecondsFinal).getMinutes()
            // horaFinal = horaFinal < 10 ? "0" + horaFinal.toString() : horaFinal.toString()
            minutosFinal = minutosFinal < 10 ? "0" + minutosFinal.toString() : minutosFinal.toString()

            var timeFinal = horaFinal + ":" + minutosFinal
            console.log(timeFinal);
           
            
            // return timeFinal;
            return this.addMinutos(this.horarioEscolhido,minutosServico)
          },

          addMinutos(horaIni, minutos){
            //60
            //assumino horaIni como 13:20
            let horaIniC = parseFloat(horaIni.split(":")[0])
            let minTotal = parseFloat(horaIni.split(":")[1]) + minutos
            // 60 + 20 = 80 minutos
            let horaFinal = Math.floor(minTotal / 60);
            let minFinal = minTotal % 60
            horaFinal = horaIniC + horaFinal

            horaFinal = horaFinal < 10 ? "0" + horaFinal.toString() : horaFinal.toString()
            minFinal = minFinal < 10 ? "0" + minFinal.toString() : minFinal.toString()

            var timeFinal = horaFinal + ":" + minFinal
            return timeFinal

          },

          async totalHorariosExibir(){
          return refConfiguracoes.get().then(ref => {
            // console.log("temp",  ref.docs[0].data().listaHorarios);
          return ref.docs[0].data().listaHorarios
          });
          
        },
          verificarHorasDisponiveis(diaBarbeiro){
              // let fatorMultiplicacao = new Date().getTimezoneOffset() != 180 ? (180 * 60 * 1000) : 0
            //transformo a data em milisecondes
            var milliseconds = new Date(this.date+"T00:00-03:00").getTime() //+ fatorMultiplicacao;
            console.log("DATEEEE", this.date);
            console.log("DATEEEE", milliseconds);
            //busco na agenda todas as horas que já foram cadastradas

            this.refAgenda
            .where("dataQuery",">=", milliseconds)
            .where("dataQuery","<=", milliseconds)
            .where("barbeiro.id", "==", this.barbeiroEscolhidoObjeto.id)
            .get().then((snap)=>{


                //ex de 1 hra
                var minutoServico = parseFloat(this.servicoEscolhidoObjeto.tempo.replace("m",""));
                var tempoServicoMilliSeconds = ((minutoServico * 60) * 1000);

                snap.forEach((doc)=>{
                  //pego o inicio e o final do agendamento (hora inicial e final)
                  let start = doc.data().start.includes(" ") ? doc.data().start.replace(" ","T") : doc.data().start
                  let end = doc.data().end.includes(" ") ? doc.data().end.replace(" ","T") : doc.data().end
                  

                  var timeInit = new Date(start+"-03:00").getTime() //+ fatorMultiplicacao;
                  var timeFim = new Date(end+"-03:00").getTime() //+ fatorMultiplicacao;
                  this.horariosFiltrados = this.horariosFiltrados.filter((hora)=>{
                    //transformo cada horário da agenda em miliseconds (junto com a data escolhida)
                    var dataString = this.date + "T" + hora+"-03:00";
                   
                    var horaVisivel = new Date(dataString).getTime() //+ fatorMultiplicacao;
                    
                    var horaAlmocoIni = new Date(this.date + "T" + diaBarbeiro.almocoIni+"-03:00").getTime()// + fatorMultiplicacao
                    var horaAlmocoFim = new Date(this.date + "T" + diaBarbeiro.almocoFim+"-03:00").getTime()// + fatorMultiplicacao
                    var horaExpedienteFim = new Date(this.date + "T" + diaBarbeiro.horaFim+"-03:00").getTime()// + fatorMultiplicacao

                    var horaVisivelFinal = horaVisivel + tempoServicoMilliSeconds;
                   
                   // Este IF checa se os horários estão batendo com AGENDAMENTOS (tanto inicio quanto FIM)
                    if(horaVisivel >= timeInit && horaVisivel < timeFim || horaVisivelFinal > timeInit && horaVisivelFinal <= timeFim){
                   /* console.log(doc.data());
                    console.log("Esconder horario");
                    console.log('horaVisivel',horaVisivel + " " + new Date(horaVisivel).getHours() + ":"+new Date(horaVisivel).getMinutes());
                    console.log('time init ',timeInit + " " + new Date(timeInit).getHours() + ":"+new Date(timeInit).getMinutes());
                    console.log('time fim',timeFim + " " + new Date(timeFim).getHours() + ":"+new Date(timeFim).getMinutes());
                    console.log('horaVisivel Soma ',horaVisivelFinal + " " + new Date(horaVisivelFinal).getHours() + ":"+new Date(horaVisivelFinal).getMinutes());
                    console.log('----------');
                    //console.log('horaVisivelFinal',horaVisivelFinal);  */                    
                      return false
                    }else{
                      if(horaVisivel < timeInit && horaVisivelFinal > timeFim){
                        return false
                      }
                      //Esconder horário de ALMOÇO com base no horario escolhido e também no término do serviço
                      if(horaVisivel >= horaAlmocoIni && horaVisivel < horaAlmocoFim || horaVisivelFinal > horaAlmocoIni && horaVisivelFinal <= horaAlmocoFim){
                        return false
                      }
                      //Esconder horário de FIM com base no horario escolhido e também no término do serviço
                      if(horaVisivelFinal > horaExpedienteFim){
                        return false
                      }
                      
                      return true

                        // console.log(Intl.DateTimeFormat().resolvedOptions().timeZone)
                      // if(horaAtual >= horaAgenda){
                      //   return false
                      // }else{

                      //   return true
                      // }
                    }
                  
                  })
                });
                //ordena do menor pro maior
                this.horariosFiltrados.sort((a,b) => a < b ? -1 : 1)
              //  console.log(this.horariosFiltrados);
              //this.barbeiroEscolhidoObjeto.horarios.horariosSemana

            });
          }
            
       
    },
    computed: {
      
      currentTitle () {
        switch (this.step) {
          case 1: return 'Escolha o serviço'
          case 2: return 'Escolha a data'
          case 3: return 'Escolha horário'
          case 4: return 'Informe seus dados'
          default: return 'Agendamento realizado!'
        }
      },
      
    },
    
    
    }
</script>

<style lang="scss" scoped>

</style>  